import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PagingSetting } from 'app/custom';

@Component({
    selector: 'pagination-control',
    template: `
        <nav class="pull-right">
            <ul class="pagination" *ngIf="pageCount > 1">
                <li *ngIf="showGoEndArrows" [class.disabled]="pageNumber === 1">
                    <a (click)="setPageNumber(1)">
                        <i
                            class="fa fa-angle-double-left"
                            [class.text-muted]="pageNumber === 1"
                        ></i>
                    </a>
                </li>
                <li
                    *ngIf="showGoNextArrows"
                    [class.disabled]="pageNumber === 1"
                >
                    <a (click)="setPageNumber(pageNumber - 1)">
                        <i
                            class="fa fa-angle-left"
                            [class.text-muted]="pageNumber === 1"
                        ></i>
                    </a>
                </li>
                <li *ngIf="pageNumber > 5">
                    <a (click)="setPageNumber(1)">1</a>
                </li>
                <li *ngIf="pageNumber > 5" class="disabled">
                    <a class="text-muted">...</a>
                </li>
                <li
                    *ngFor="let number of numberRange"
                    [class.active]="number === pageNumber"
                >
                    <a (click)="setPageNumber(number)">{{ number }}</a>
                </li>
                <li *ngIf="pageNumber < pageCount - 4" class="disabled">
                    <a class="text-muted">...</a>
                </li>
                <li *ngIf="pageNumber < pageCount - 4">
                    <a (click)="setPageNumber(pageCount)">{{ pageCount }}</a>
                </li>
                <li
                    *ngIf="showGoNextArrows"
                    [class.disabled]="pageNumber === pageCount"
                >
                    <a (click)="setPageNumber(pageNumber + 1)">
                        <i
                            class="fa fa-angle-right"
                            [class.text-muted]="pageNumber === pageCount"
                        ></i>
                    </a>
                </li>
                <li
                    *ngIf="showGoEndArrows"
                    [class.disabled]="pageNumber === pageCount"
                >
                    <a (click)="setPageNumber(pageCount)">
                        <i
                            class="fa fa-angle-double-right"
                            [class.text-muted]="pageNumber === pageCount"
                        ></i>
                    </a>
                </li>
            </ul>
        </nav>
    `
})
export class PaginationControlsComponent implements OnInit {
    @Input() public pagingSetting: PagingSetting;
    @Input() public pageNumber: number;
    @Output() public pageNumberChange = new EventEmitter<number>();
    @Input() public totalCount: number;

    @Input() public showGoNextArrows: boolean = true;
    @Input() public showGoEndArrows: boolean = false;

    @Input() public numbersAroundCurrent = 2;

    ngOnInit(): void {}

    public get pageCount(): number {
        return Math.ceil(this.totalCount / this.pagingSetting.pageSize);
    }

    get middleNumberCount(): number {
        return this.numbersAroundCurrent * 2 + 1;
    }

    protected get numberRange(): number[] {
        if (
            this.pageNumber > this.middleNumberCount &&
            this.pageNumber < this.pageCount - (this.middleNumberCount - 1)
        ) {
            return Array(this.middleNumberCount)
                .fill(0)
                .map((x, i) => this.pageNumber - this.numbersAroundCurrent + i)
                .filter((val) => val > 0 && val <= this.pageCount);
        }
        if (this.pageNumber >= this.pageCount - (this.middleNumberCount - 1)) {
            return Array(this.middleNumberCount + 2)
                .fill(0)
                .map(
                    (x, i) => this.pageCount - (this.middleNumberCount + 1) + i
                )
                .filter((val) => val > 0 && val <= this.pageCount);
        }
        return Array(this.middleNumberCount + 2)
            .fill(0)
            .map((x, i) => i + 1)
            .filter((val) => val > 0 && val <= this.pageCount);
    }

    protected setPageNumber(num) {
        if (num > 0 && num <= this.pageCount) {
            this.pageNumber = num;
            this.pageNumberChange.emit(this.pageNumber);
        }
    }
}
